<template>
  <div v-if="size" id="mainCarouselNews" class="nlhpc-noticias mx-0 px-0 mb-0">
    <div class="row noticias-banner pt-3 pb-2">
      <div class="col">
        <div class="container">
          <div class="row">
            <div class="col-12 col-lg-2">
              <i class="far fa-newspaper"></i>
              <span>&nbsp;&nbsp;&nbsp;NOTICIAS</span>
            </div>

            <div class="col-12 col-lg-10">
              <div
                id="carouselNews"
                class="carousel slide"
                style="text-align: left"
                data-bs-ride="carousel"
                data-bs-interval="5000"
              >
                <div class="carousel-inner">
                  <div
                    v-for="(noticia, index) in noticias"
                    :key="index"
                    :id="`noticia-${index}`"
                    class="carousel-item nlhpc-carousel text-md-center text-xl-start"
                  >
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <a :href="noticia.link" target="_blank" class="nlhpc-noticias-text">
                      <b>{{ noticia.titulo }} : </b>
                      {{ getResume(noticia.titulo, noticia.resumen) }}
                    </a>
                  </div>
                </div>
                <button
                  class="carousel-control-prev float-start"
                  type="button"
                  data-bs-target="#carouselNews"
                  data-bs-slide="prev"
                >
                  <span class="carousel-control-prev-icon" aria-hidden="true"> </span>
                  <span class="visually-hidden">Previous</span>
                </button>
                <button
                  class="carousel-control-next float-end"
                  type="button"
                  data-bs-target="#carouselNews"
                  data-bs-slide="next"
                >
                  <span class="carousel-control-next-icon" aria-hidden="true"> </span>
                  <span class="visually-hidden">Next</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row nlhpc-separador">
      <div class="col-6 nlhpc-separador-izq"></div>
      <div class="col-6 nlhpc-separador-der"></div>
    </div>
  </div>
</template>

<!-- eslint-disable no-undef -->
<script>
import axios from "axios";

export default {
  name: "BannerNoticias",
  data() {
    return {
      noticias: {},
      size: 0,
      largo: 85,
    };
  },
  methods: {
    getResume(title, text) {
      if (this.size) {
        let largo = (title + text).length;
        let fin = this.largo - title.length;
        let mensaje = text ? text.substring(0, fin) : "";
        if (largo >= this.largo) return mensaje + "...    ";
        return text;
      }
    },

    async getData() {
      let API_BASE_URL = process.env.VUE_APP_API_URL;
      let request = await axios.get(`${API_BASE_URL}/dashboard/noticias`);
      
      if (request.status === 200) {
        this.noticias = request.data.noticias;
        this.size = this.noticias.length;
        localStorage.setItem("hasNoticias", this.size);
        return;
      } 

      localStorage.setItem("hasNoticias", 0);
      return;
    },

    async initNews() {
      await this.getData();
      let el = document.querySelector("#noticia-0");
      if (this.size && !!el) el.classList.add("active");
    },
  },

  mounted() {
    this.initNews();
    setInterval(async () => this.initNews(), 60000);

    this.$nextTick(() => {
      let el = document.querySelector("#noticia-0");
      if (this.size && !!el) el.classList.add("active");
    });

    document.addEventListener("visibilitychange", () => {
      if (!document.hidden) {
        let items = document.querySelectorAll("#carouselNews .carousel-item");
        items.forEach((el) => el.classList.remove("active"));
        if (items.length) items[0].classList.add("active");
      }
    });
  },
};
</script>

<style scoped>
.news-banner {
  width: 100%;
  height: 30px;
  overflow: hidden;
  text-align: left;
}

.news-list {
  list-style: none;
  margin: 0;
  padding: 0;
  animation: scrollUp 10s linear infinite;
}

.news-item {
  line-height: 30px;
}

@keyframes scrollUp {
  0% {
    transform: translateY(0);
  }
  20% {
    transform: translateY(0);
  }
  25% {
    transform: translateY(-30px);
  }
  45% {
    transform: translateY(-30px);
  }
  50% {
    transform: translateY(-60px);
  }
  70% {
    transform: translateY(-60px);
  }
  75% {
    transform: translateY(-90px);
  }
  95% {
    transform: translateY(-90px);
  }
  100% {
    transform: translateY(-120px);
  }
}

.news-banner:hover .news-list {
  animation-play-state: paused;
}

.carousel-control-prev,
.carousel-control-next {
  width: 25px;
  height: 25px;
  background-color: rgba(0, 0, 0, 0.3);
  border-radius: 50%;
  font-size: 20px;
  line-height: 50px;
  text-align: center;
  /* top: 50%; */
  /* transform: translateY(-25px); */
}

.carousel-control-prev-icon,
.carousel-control-next-icon {
  color: #fff;
  height: 20px;
}

.carousel-control-prev:hover,
.carousel-control-next:hover {
  background-color: rgba(0, 0, 0, 0.8);
}
</style>
